module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_2_3.61c1f998.jpeg";